import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'shared-core-material-icon',
  template: `{{ name() }}`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: 'material-icon.component.scss',
})
export class MaterialIconComponent {
  @HostBinding('class')
  readonly class = 'material-icons';

  readonly name = input.required<string>();
}
